// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.AgencyModal_boxModal__i8zaV {
  animation: AgencyModal_init__4gvEJ 0.3s;
  transition: 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  overflow: scroll;
  overflow-x: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  border-radius: 5px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
}

.AgencyModal_boxModal__i8zaV .AgencyModal_exit__DQMMb {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
  margin-bottom: 40px;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_exit__DQMMb .AgencyModal_exitIcon__SIYvk {
  transition: 0.3s;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_exit__DQMMb .AgencyModal_exitIcon__SIYvk:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.AgencyModal_boxModal__i8zaV .AgencyModal_titleModal__yOOum {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_titleModal__yOOum p {
  font-size: 1.3rem;
  margin: 0;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_titleModal__yOOum span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_loader__zDhYA {
  transition: 0.5s;
  min-height: 40vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_search__NSv8k {
  animation: AgencyModal_init3__IRq1w 0.3s both 0.3s;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_data__--zwy {
  transition: 0.5s;
  max-height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_data__--zwy .AgencyModal_tableContainer__aMOtF {
  animation: AgencyModal_init2__Y9td2 0.3s both 0.3s;
  overflow-y: scroll;
  max-height: 100%;
  border-radius: 3px;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_noresult__UMixU {
  animation: AgencyModal_init3__IRq1w 0.3s both 0.3s;
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.6rem;
  font-weight: 300;
}

.AgencyModal_boxModal__i8zaV .AgencyModal_pagination__ovkDA {
  animation: AgencyModal_init3__IRq1w 0.3s both 0.3s;
}

@media screen and (max-width: 900px) {
  .AgencyModal_boxModal__i8zaV {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}

@keyframes AgencyModal_init__4gvEJ {
  0% {
    top: 55%;
    opacity: 0;
  }
  100% {
    top: 50%;
    opacity: 1;
  }
}

@keyframes AgencyModal_init2__Y9td2 {
  0% {
    transform: translateX(30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes AgencyModal_init3__IRq1w {
  0% {
    transform: translateX(-30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/AgencyModal/AgencyModal.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,uCAAoB;EACpB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kDAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kDAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kDAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kDAA+B;AACjC;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  animation: init 0.3s;\n  transition: 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  overflow: scroll;\n  overflow-x: hidden;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: 90%;\n  border-radius: 5px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n  margin-bottom: 40px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.3rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .loader {\n  transition: 0.5s;\n  min-height: 40vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .search {\n  animation: init3 0.3s both 0.3s;\n}\n\n.boxModal .data {\n  transition: 0.5s;\n  max-height: 50vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .data .tableContainer {\n  animation: init2 0.3s both 0.3s;\n  overflow-y: scroll;\n  max-height: 100%;\n  border-radius: 3px;\n}\n\n.boxModal .noresult {\n  animation: init3 0.3s both 0.3s;\n  min-height: 40vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.6rem;\n  font-weight: 300;\n}\n\n.boxModal .pagination {\n  animation: init3 0.3s both 0.3s;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n@keyframes init {\n  0% {\n    top: 55%;\n    opacity: 0;\n  }\n  100% {\n    top: 50%;\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(30px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes init3 {\n  0% {\n    transform: translateX(-30px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `AgencyModal_boxModal__i8zaV`,
	"init": `AgencyModal_init__4gvEJ`,
	"exit": `AgencyModal_exit__DQMMb`,
	"exitIcon": `AgencyModal_exitIcon__SIYvk`,
	"titleModal": `AgencyModal_titleModal__yOOum`,
	"loader": `AgencyModal_loader__zDhYA`,
	"search": `AgencyModal_search__NSv8k`,
	"init3": `AgencyModal_init3__IRq1w`,
	"data": `AgencyModal_data__--zwy`,
	"tableContainer": `AgencyModal_tableContainer__aMOtF`,
	"init2": `AgencyModal_init2__Y9td2`,
	"noresult": `AgencyModal_noresult__UMixU`,
	"pagination": `AgencyModal_pagination__ovkDA`
};
export default ___CSS_LOADER_EXPORT___;
